import {
  PublicClientApplication,
  InteractionRequiredAuthError
} from '@azure/msal-browser'
import { getMsalConfig, loginRequest } from 'connection/AuthConfig'
import { HttpConstants } from 'constants/HttpConstants'
import { PushNotification } from 'utils/PushNotification'
import axios from 'axios'

let mfaMsalInstance = null

const initializeMfaMsal = async () => {
  if (!mfaMsalInstance) {
    const msalConfig = await getMsalConfig('mfa')
    mfaMsalInstance = new PublicClientApplication(msalConfig)
  }
  return mfaMsalInstance
}

const getMfaAccount = async instance => {
  const mfaConfig = await getMsalConfig('mfa')
  const tenantId = mfaConfig.auth.authority.split('/')[3]
  const accounts = instance.getAllAccounts()

  if (accounts.length > 0) {
    return accounts.find(acc => acc.homeAccountId.includes(tenantId)) || null
  }
  return null
}

export const getMfaToken = async () => {
  const instance = await initializeMfaMsal()
  let account = await getMfaAccount(instance)

  if (!account) {
    try {
      const loginResponse = await instance.loginPopup(loginRequest)
      account = loginResponse.account
    } catch (error) {
      PushNotification.error('Erro durante o login no tenant de MFA:', error)
      throw error
    }
  }

  try {
    const tokenResponse = await instance.acquireTokenSilent({
      ...loginRequest,
      account: account
    })
    return tokenResponse.accessToken
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      try {
        const tokenResponse = await instance.acquireTokenPopup({
          ...loginRequest,
          account: account
        })
        return tokenResponse.accessToken
      } catch (popupError) {
        throw popupError
      }
    }
    throw error
  }
}

const cerberusMfaApi = axios.create({ baseURL: '' })

cerberusMfaApi.interceptors.request.use(async config => {
  const mfaToken = await getMfaToken()

  config.headers[HttpConstants.HEADER_CONTENT] = HttpConstants.TYPE_JSON
  config.headers[HttpConstants.AUTHORIZATION] = `Bearer ${mfaToken}`

  return config
})

export default cerberusMfaApi
